var map = {
	"./ch/Phone_01.jpg": "c459",
	"./ch/Phone_02.jpg": "62b5",
	"./ch/Phone_03.jpg": "bb72",
	"./ch/Phone_04.jpg": "503e",
	"./ch/Phone_05.jpg": "8771",
	"./ch/Phone_06.jpg": "ca3f",
	"./ch/Phone_07.jpg": "6c17",
	"./ch/Phone_08.jpg": "c190",
	"./en/Phone_01.jpg": "ac0a",
	"./en/Phone_02.jpg": "4d9a",
	"./en/Phone_03.jpg": "d4a4",
	"./en/Phone_04.jpg": "a676",
	"./en/Phone_05.jpg": "285d",
	"./en/Phone_06.jpg": "5b92",
	"./en/Phone_07.jpg": "fdd2",
	"./en/Phone_08.jpg": "e3b9",
	"./zh/Phone_01.jpg": "3212",
	"./zh/Phone_02.jpg": "4237",
	"./zh/Phone_03.jpg": "967d",
	"./zh/Phone_04.jpg": "0c30",
	"./zh/Phone_05.jpg": "f6c8",
	"./zh/Phone_06.jpg": "1afa",
	"./zh/Phone_07.jpg": "8ebe",
	"./zh/Phone_08.jpg": "a31a"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "71dc";